<div class="row" class="table-row">
  <table mat-table [dataSource]="ingredients" class="mat-elevation-z8">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getNameText() }}
      </th>
      <th></th>
      <td mat-cell *matCellDef="let ingredient" class="ingredient-name-cell">
        {{ ingredient.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="otherNames">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getOtherNamesText() }}
      </th>
      <td mat-cell *matCellDef="let ingredient">
        <mat-chip-set>
          @for (otherName of ingredient.otherNames; track otherName) {
            <mat-chip>{{ otherName }}</mat-chip>
          }
        </mat-chip-set>
      </td>
    </ng-container>
    <ng-container matColumnDef="casNumbers">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getCasNumbersText() }}
      </th>
      <td mat-cell *matCellDef="let ingredient">
        <mat-chip-set>
          @for (casNumber of ingredient.casNumbers; track casNumber) {
            <mat-chip>{{ casNumber }}</mat-chip>
          }
        </mat-chip-set>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let ingredient">
        <a
          class="dark-link-underline"
          [routerLink]="['/ingredients/' + ingredient.id + '/edit']"
          >{{ translationService.getEditText() }}</a
        >
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
